import React from 'react';
import { Text, i18n, localizationMaps, tokens } from '@simplybenefits/sb-ui-library';
import { numberWithCommas } from '../services/helpers.js';

/**
 * Renders a component based on the specified parameters.
 *
 * @param {string} param - The parameter determining the type of rendering.
 * @param {string | number} value - The value to be rendered.
 * 
 * @returns {React.ReactNode} The rendered component.
 */
const _renderSwitch = (param, value) => {
    switch (param) {
        case 'percent':
            return <Text small>{`${ value }%` }</Text>;
        case 'header':
            return <Text small bold>{value}</Text>;
        case 'age':
            return <Text small>{ localizationMaps.fromEnglish("rolloverOptions", value)}</Text>;
        case 'days':
            return <Text small> {value === 0 ? 'none' : value === 1 ? i18n.t(tokens.labels.coverage.oneDay) : `${ value } ${ i18n.t(tokens.labels.coverage.days) }` } </Text>;
        default:
            return <Text small>{ `$${ numberWithCommas(value.toFixed(2)) }` }</Text>;
    }
};

const styles = {
    row: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 5,
        marginBottom: 10
    }
};

/**
 *
 * @param type
 * @param title
 * @param value
 * @param {*} param0
 */
const CoverageBlock = ({ title, value, type, isCombined }) => (
    <div style={styles.row}>
        <Text small bold={type === 'header'} customStyle={{ flex: 1 }}>{title}</Text>
        {!isCombined && _renderSwitch(type, value)}
    </div>
);

export default (CoverageBlock);